import React, { useState, useEffect } from 'react';
import api from '../api';

// Weekly cross-client summary email: manage the recipient list + send on demand.
export default function WeeklySummarySettings() {
  var _r = useState([]), recipients = _r[0], setRecipients = _r[1];
  var _o = useState([]), original = _o[0], setOriginal = _o[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _s = useState(false), saving = _s[0], setSaving = _s[1];
  var _sn = useState(false), sending = _sn[0], setSending = _sn[1];
  var _ne = useState(''), newEmail = _ne[0], setNewEmail = _ne[1];
  var _m = useState(null), message = _m[0], setMessage = _m[1];

  useEffect(function() { loadData(); }, []);

  function flash(type, text) {
    setMessage({ type: type, text: text });
    setTimeout(function() { setMessage(null); }, 3000);
  }

  function loadData() {
    api.getWeeklyRecipients().then(function(d) {
      var list = d.emails || [];
      setRecipients(list);
      setOriginal(list);
      setLoading(false);
    }).catch(function(e) { console.error(e); setLoading(false); });
  }

  function isValidEmail(e) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e);
  }

  function addEmail() {
    var e = (newEmail || '').trim();
    if (!e) return;
    if (!isValidEmail(e)) { flash('error', 'כתובת אימייל לא תקינה'); return; }
    if (recipients.indexOf(e) >= 0) { flash('error', 'הכתובת כבר קיימת'); return; }
    setRecipients(recipients.concat([e]));
    setNewEmail('');
  }

  function removeEmail(e) {
    setRecipients(recipients.filter(function(x) { return x !== e; }));
  }

  function handleSave() {
    setSaving(true);
    api.updateWeeklyRecipients(recipients).then(function(d) {
      var list = d.emails || [];
      setRecipients(list);
      setOriginal(list);
      setSaving(false);
      flash('success', 'רשימת הנמענים נשמרה');
    }).catch(function(e) {
      setSaving(false);
      flash('error', 'שגיאה: ' + e.message);
    });
  }

  function handleSendNow() {
    setSending(true);
    api.runWeeklySummary().then(function() {
      setSending(false);
      flash('success', 'הסיכום נשלח לתור העיבוד');
    }).catch(function(e) {
      setSending(false);
      flash('error', 'שגיאה: ' + e.message);
    });
  }

  if (loading) return React.createElement('div', { style: { padding: '20px', color: 'var(--text-muted)', fontSize: '13px' } }, 'טוען הגדרות...');

  var hasChanges = JSON.stringify(recipients) !== JSON.stringify(original);

  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '14px' } },
    React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' } },
      React.createElement('div', null,
        React.createElement('div', { style: { fontSize: '15px', fontWeight: 700 } }, 'סיכום שבועי במייל'),
        React.createElement('div', { style: { fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' } }, 'סיכום שבועי אחד לכל הלקוחות, כלול במייל ההתראות של יום ראשון (07:30). הגדר למי לשלוח.')
      ),
      React.createElement('div', { style: { display: 'flex', gap: '8px' } },
        React.createElement('button', {
          onClick: handleSendNow, disabled: sending || recipients.length === 0,
          title: recipients.length === 0 ? 'הוסף נמען לפני שליחה' : 'שלח עכשיו לבדיקה',
          style: { padding: '6px 14px', background: 'var(--surface)', color: 'var(--accent)', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', fontWeight: 600, cursor: (sending || recipients.length === 0) ? 'not-allowed' : 'pointer', opacity: (sending || recipients.length === 0) ? 0.6 : 1, fontFamily: 'var(--sans)' }
        }, sending ? 'שולח...' : 'שלח עכשיו'),
        hasChanges ? React.createElement('button', {
          onClick: handleSave, disabled: saving,
          style: { padding: '6px 16px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 600, cursor: saving ? 'wait' : 'pointer', opacity: saving ? 0.6 : 1, fontFamily: 'var(--sans)' }
        }, saving ? 'שומר...' : 'שמור שינויים') : null
      )
    ),
    message ? React.createElement('div', {
      style: { padding: '8px 14px', borderRadius: '6px', fontSize: '12px', background: message.type === 'success' ? 'var(--green-glow)' : 'var(--red-glow)', color: message.type === 'success' ? 'var(--green)' : 'var(--red)', border: '1px solid ' + (message.type === 'success' ? 'var(--green)' : 'var(--red)') }
    }, message.text) : null,

    // Recipient chips
    recipients.length > 0 ? React.createElement('div', { style: { display: 'flex', gap: '8px', flexWrap: 'wrap' } },
      recipients.map(function(e) {
        return React.createElement('span', { key: e, style: { display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '5px 10px', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '16px', fontSize: '12px', fontFamily: 'var(--mono)' } },
          e,
          React.createElement('button', {
            onClick: function() { removeEmail(e); },
            title: 'הסר',
            style: { border: 'none', background: 'none', color: 'var(--red)', cursor: 'pointer', fontSize: '14px', lineHeight: 1, padding: 0 }
          }, '×')
        );
      })
    ) : React.createElement('div', { style: { fontSize: '12px', color: 'var(--text-muted)', padding: '8px 12px', background: 'var(--bg)', border: '1px dashed var(--border)', borderRadius: '6px' } }, 'אין נמענים מוגדרים — הסיכום השבועי לא יישלח עד שתוסיף כתובת.'),

    // Add input
    React.createElement('div', { style: { display: 'flex', gap: '8px' } },
      React.createElement('input', {
        type: 'email', value: newEmail, placeholder: 'name@example.com', dir: 'ltr',
        onChange: function(ev) { setNewEmail(ev.target.value); },
        onKeyDown: function(ev) { if (ev.key === 'Enter') { ev.preventDefault(); addEmail(); } },
        style: { flex: 1, padding: '7px 10px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', fontSize: '13px', fontFamily: 'var(--mono)' }
      }),
      React.createElement('button', {
        onClick: addEmail,
        style: { padding: '7px 16px', background: 'var(--surface)', color: 'var(--text-secondary)', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--sans)' }
      }, '+ הוסף')
    )
  );
}
